import itemsSubcategory from '~/util/stips/category/itemsSubcategory';
import findIncludes from './typeIncludesText';
import findMonthLocalization from './findMonth';

// Sajt je samo na srpskom: parametar `lang` se zadržava zbog postojećih poziva, ali se ne koristi.
export default class LocalizationLang{
    static findLang(lang, products){
      return itemsSubcategory.subcategory.filter(x=>{
        let path = x.food == true ? x.food_filter_path : x.title_path;
        if(path.toLowerCase() == products.split('-').join(' ')) return true;
      })
    }
    static findLangSingleproducts(lang, singleproducts){
      let findSr =  itemsSubcategory.subcategory.filter(x=> x.value_path == findIncludes.convert(singleproducts.split(' ').join('-'),2,lang));
      if(findSr.length > 0){
        return { subcategory : findSr[0],
          path_sr : this.createPath(findSr[0],singleproducts,lang)
        }
      }
      return { subcategory : null,
        path_sr : '',
      }
    }
  static findLangWeeks(lang,weeks){
    let findSr =  itemsSubcategory.subcategory.filter(x=> x.value_path == findIncludes.convert(weeks.split(' ').join('-'),2,lang));
    if(findSr.length > 0){
      return { subcategory : findSr[0],
               path_sr : this.createWeekSrPath(findSr[0],weeks).split(' ').join('-').toLowerCase()
              }
    }
    return {  subcategory : null,
      path_sr : '',
    }
  }
  static createPath(subcategory,singleproducts,lang){
        if(subcategory)return subcategory.description_path.split(' ').join('-').toLowerCase()+'-'+subcategory.value_path.split(' ').join('-').toLowerCase()+'-'+subcategory.catgeory_path+'-'+singleproducts.split('-')[singleproducts.split('-').length-1];
        else return '';
      }
  static createWeekSrPath(subcategory,weeks){
    let month = this.creteMonth(weeks);
    if(subcategory)return `${subcategory.description_path.toLowerCase()} za mesec ${findMonthLocalization.srMonth(month.intMonth)} od ${month.firstDate} do ${month.lastDate} ${subcategory.value_path.toLowerCase()} ${subcategory.catgeory_path} ${weeks.split('-')[weeks.split('-').length-1]}`;
    else return '';
  }
   static creteMonth(weeks){
     let firstDate ='';
     let lastDate ='';
     let intMonth ='';
    if(weeks.includes('mesec') &&  weeks.includes('-od-') ){
      let month = weeks.split('-od-')[1].split('-');
      firstDate = month[0];
      lastDate = month[2];
      intMonth = month[0].split('.')[1].split(' ').join('');

    }
    return {
      firstDate,
      lastDate,
      intMonth
}
   }
}
